import React, {useCallback} from 'react';

import {Group} from '@pb/kit-component-group';

import {RemoveButton} from './remove-button';

import type {OnRemoveRange, RangesItemDto} from './typedef';


type Props = {
    isSingleAddress?: boolean,
    rangeId: string,
    rangesBusy: boolean,
    data: RangesItemDto,
    onRemove: OnRemoveRange,
    disabled?: boolean,
};
export const RangeItem = (props: Props) => {
    const {data: {start, end}, rangesBusy, rangeId, onRemove, isSingleAddress, disabled} = props;

    const onRemoveCallback = useCallback(() => {
        onRemove(rangeId);
    }, [rangeId, onRemove]);

    return (
        <Group gap="xs" alignItems="center">
            <strong>{start}</strong>
            {!isSingleAddress ? <div>—</div> : null}
            {!isSingleAddress ? <strong>{end}</strong> : null}
            <RemoveButton {...{disabled: rangesBusy || disabled, onRemove: onRemoveCallback}}/>
        </Group>
    );
};
